import React from 'react';

import classNames from 'classnames';

export default function ModalHeader(props) {
    return (
        <div className="tw-flex tw-flex-row tw-items-center tw-justify-between tw-gap-x-4 tw-mb-4 tw-rounded-t">
            <div>
                <h3 className={classNames('tw-text-2xl tw-font-semibold', props.dark ? 'tw-text-charcoal' : 'tw-text-blue')}>
                    {props.children ? props.children : props.title}
                </h3>
                {props.subtitle && <div className="tw-text-sm tw-text-charcoal-75">{props.subtitle}</div>}
            </div>
            <svg
                onClick={props.close}
                className="tw-w-4 tw-h-4 tw-text-charcoal-75 hover:tw-text-charcoal tw-cursor-pointer tw-flex-shrink-0 tw-self-start"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
            >
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
            </svg>
        </div>
    );
}
